import moment from "moment";

export const getDriverStartdate = (allocationList, driverId) => {
    allocationList.map((item, index) => {
        if (item.DriverId === driverId) {
            const startDate = moment(item.StartDate, "YYYY-MM-DD")
                .format("Do MMM YYYY")
                .toString();
        }
    });
};

export const getFormattedDate = (date, fromFormat) => {
    
    return moment(date, fromFormat).format("Do MMM YYYY").toString();
};



// WEBPACK FOOTER //
// ./src/features/relocations/helper.js